import { z } from 'zod'

import type {
  SensorCalibrationId,
  UserId,
  CableId,
  SensorCalibration,
} from '../../index.js'
import { cableId, userId, sensorCalibrationId } from '../../index.js'

// extendedSensorInitializer extends the base sensorInitializer by making the cableId optional if cableSerial is provided

export const extendedSensorCalibrationInitializer = z
  .object({
    id: sensorCalibrationId.optional(),
    createdAt: z.coerce.date().optional().nullable(),
    createdBy: userId.optional().nullable(),
    updatedAt: z.coerce.date().optional().nullable(),
    updatedBy: userId.optional().nullable(),
    deletedAt: z.coerce.date().optional().nullable(),
    deletedBy: userId.optional().nullable(),
    sensorId: z.string(),
    cableId: cableId.optional(),
    cableSerial: z.number().optional(),
    calibrationId: z.number().optional().nullable(),
    sensorNumber: z.number(),
    calibrationOffset: z.number().optional().nullable(),
  })
  .refine(
    (data) => {
      // Ensure that either cableId or cableSerial is provided
      return data.cableId !== undefined || data.cableSerial !== undefined
    },
    {
      message: 'Either cableId or cableSerial must be provided',
    },
  ) as unknown as z.Schema<ExtendedSensorCalibrationInitializer>

export type ExtendedSensorCalibrationInitializer = {
  id?: SensorCalibrationId
  createdAt?: Date | null
  createdBy?: UserId
  updatedAt?: Date | null
  updatedBy?: UserId
  deletedAt?: Date | null
  deletedBy?: UserId
  sensorId: string
  cableId?: CableId
  cableSerial?: number
  calibrationId?: SensorCalibrationId | null
  sensorNumber: number
  calibrationOffset?: number | null
}

export const extendedSensorCalibrationMutator = z
  .object({
    id: sensorCalibrationId.optional(),
    createdAt: z.coerce.date().optional().nullable(),
    createdBy: userId.optional().nullable(),
    updatedAt: z.coerce.date().optional().nullable(),
    updatedBy: userId.optional().nullable(),
    deletedAt: z.coerce.date().optional().nullable(),
    deletedBy: userId.optional().nullable(),
    sensorId: z.string(),
    cableId: cableId.optional(),
    cableSerial: z.number().optional(),
    calibrationId: z.number(),
    sensorNumber: z.number(),
    calibrationOffset: z.number().optional().nullable(),
  })
  .refine(
    (data) => {
      // Ensure that either cableId or cableSerial is provided
      return data.cableId !== undefined || data.cableSerial !== undefined
    },
    {
      message: 'Either cableId or cableSerial must be provided',
    },
  ) as unknown as z.Schema<ExtendedSensorCalibrationInitializer>

export type ExtendedSensorCalibrationMutator = Omit<
  ExtendedSensorCalibrationInitializer,
  'id'
> & {
  id: SensorCalibrationId
}

export type ExtendedSensorCalibration = SensorCalibration & {
  cableSerial?: number | null
  calibrationEventDate?: Date | string | null
}
